__turbopack_context__.v({
  "morpher": "_7sV8qq_morpher",
  "root": "_7sV8qq_root",
  "text": "_7sV8qq_text",
  "wordAnim": "_7sV8qq_wordAnim",
});
